import service from '@/util/HttpUtil'
// const domain = 'http://test.weicistudy.com:83'
// const domain = 'http://api.weicistudy.com'

function getInfo(userCode, session, appId, bannerId) {
    return service.get('/activity/banner/info', {
        params: {
            user_code: userCode,
            session: session,
            app_id: appId,
            banner_id: bannerId
        }
    });
}

function apply(userCode, session, appId, bannerId) {
    return service.get('/activity/sign/up', {
        params: {
            user_code: userCode,
            session: session,
            app_id: appId,
            banner_id: bannerId
        }
    });
}

function draw(userCode, session, appId, bannerId) {
    return service.post('/activity/draw', {
        user_code: userCode,
        session: session,
        app_id: appId,
        banner_id: bannerId
    });
}

function list(userCode, session, appId, bannerId) {
    return service.get('/activity/winer/list', {
        params: {
            user_code: userCode,
            session: session,
            app_id: appId,
            banner_id: bannerId
        }
    });
}

export default {
    getInfo,
    apply,
    draw,
    list
}




